import { render, staticRenderFns } from "./MySelectChipsCustomText.vue?vue&type=template&id=2cba089e&scoped=true&"
import script from "./MySelectChipsCustomText.vue?vue&type=script&lang=js&"
export * from "./MySelectChipsCustomText.vue?vue&type=script&lang=js&"
import style0 from "./MySelectChipsCustomText.vue?vue&type=style&index=0&id=2cba089e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba089e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VIcon,VSelect,VTextField})
